import React, { useState, useEffect } from "react";
import { withNamespaces } from "react-i18next";
import axios from "axios";

import { Alert } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";

import customStyles from "../../../../assets/select/customStyles";
import Select from "react-select";

import usFlag from "../../../../assets/images/flags/us.jpg";
import gerFlag from "../../../../assets/images/flags/germany.jpg";

import Checkbox from "@material-ui/core/Checkbox";

const CreateEditUser = (props) => {
  let link = localStorage.getItem("link");
  let data = props.data;
  let roles = props.dataRoles;
  let rolesUI = props.dataRolesUI;

  const [username, setUsername] = useState();
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [email, setEmail] = useState();
  const [heading, setHeading] = useState("");
  const [enabled, setEnabled] = useState(true);
  const [roleIDs, setRoleIDs] = useState([]);
  const [rolesList, setRolesList] = useState([]);
  const [roleDefaultRights, setRoleDefaultRights] = useState([]);
  const [addRights, setAddRights] = useState([]);
  const [toggleRights, setToggleRights] = useState(false);
  const [failShow, setFailShow] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  const [selectedRoles, setSelectedRoles] = useState([]);
  const [language, setLanguage] = useState({
    value: "de",
    label: (
      <div className="flex-iac settings-item">
        <img src={gerFlag} className="select-icon" style={{ width: "22px" }} />{" "}
        {props.t("allgemein.sprachen.de")}
      </div>
    ),
  });
  const [selectedDepartment, setSelectedDepartment] = useState();
  const [optionsDepartments, setOptionsDepartments] = useState();

  const optionsLanguages = [
    {
      value: "de",
      label: (
        <div className="flex-iac settings-item">
          <img
            src={gerFlag}
            className="select-icon"
            style={{ width: "22px" }}
          />{" "}
          {props.t("allgemein.sprachen.de")}
        </div>
      ),
    },
    {
      value: "en",
      label: (
        <div className="flex-iac settings-item">
          <img src={usFlag} className="select-icon" style={{ width: "22px" }} />{" "}
          {props.t("allgemein.sprachen.en")}
        </div>
      ),
    },
  ];

  function languageChange(value) {
    setLanguage(value);
  }

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("JWT");
  }, [localStorage.getItem("JWT")]);

  useEffect(() => {
    let rolesList = [];
    let roleDefaultRightsIds = [];
    for (let i = 0; i < roles.length; i++) {
      rolesList.push({
        value: roles[i].roleID,
        label: (
          <div className="flex-iac settings-item">{roles[i].roleName}</div>
        ),
      });
      if (i == 0) roleDefaultRightsIds = roles[i].rightIds;
    }
    setRolesList(rolesList);

    let userName = "";
    let eMail = "";
    let heading = props.t("administration.benutzer.newUser");
    let enabled = false;
    let roleIDs = [];
    let rightIDs = [];
    let languageCode = language;
    let selectedPrevRoles = [rolesList[0]];

    if (data != null) {
      data.userName != null ? (userName = data.userName) : (userName = "");
      data.eMail != null ? (eMail = data.eMail) : (eMail = "");
      heading = props.t("administration.benutzer.editUser");
      data.enabled != null ? (enabled = !!data.enabled) : (enabled = false);
      data.languageCode != null
        ? (languageCode = optionsLanguages.filter(
            (item) => item.value == data.languageCode
          ))
        : (languageCode = language);
      data.roleIDs != null ? (roleIDs = data.roleIDs) : (roleIDs = []);

      data.additionalRights != null
        ? (rightIDs = data.additionalRights)
        : (rightIDs = []);

      if (roleIDs.length > 0) {
        selectedPrevRoles = rolesList.filter((item) =>
          roleIDs.includes(item.value)
        );

        let selectedPrevRoleRights = roles.filter(
          (item) => item.roleID == selectedPrevRoles[0].value
        );

        roleDefaultRightsIds = selectedPrevRoleRights[0].rightIds;
      }
    }
    setSelectedRoles(selectedPrevRoles);
    setUsername(userName);
    setEmail(eMail);
    setLanguage(languageCode);
    setHeading(heading);
    setRoleIDs(roleIDs);
    setRoleDefaultRights(roleDefaultRightsIds);
    setAddRights(rightIDs);
    setEnabled(enabled);

    axios.get(link + '/api/UserDepartments/SelectValues', {}).then((response) => {
      const departments = response.data;
      setOptionsDepartments(departments);

      if (data.departmentId != null) {
        setSelectedDepartment(departments.find(d => d.value === data.departmentId));
      }
    })
        .catch((error) => {
          console.error("Error while loading Departments", error);
        });
  }, [props]);

  let selectedType = props.type;

  function onRoleChange(value) {
    setSelectedRoles([value]);
    let currentRole = roles.filter((val) => val.roleID == value.value);
    let currentRoleRights = currentRole[0].rightIds;
    setRoleDefaultRights(currentRole[0].rightIds);

    const result = addRights.filter(
      (item) => !currentRoleRights.includes(item)
    );
    setAddRights(result);
  }

  function usernameChange(props) {
    setUsername(props);
    setFailShow(false);
  }

  function passwordChange(props) {
    setPassword(props);
    setFailShow(false);
  }

  function passwordChangeConfirm(props) {
    setPasswordConfirm(props);
    setFailShow(false);
  }

  function emailChange(props) {
    setEmail(props);
    setFailShow(false);
  }

  function toggleRightsSwitch() {
    setToggleRights(!toggleRights);
  }

  const onAdditionalRightsChange = (e) => {
    if (e.target.checked === true) {
      setAddRights([...addRights, parseInt(e.target.value)]);
    } else if (e.target.checked === false) {
      let freshArray = addRights.filter(
        (val) => val !== parseInt(e.target.value)
      );
      setAddRights([...freshArray]);
    }
  };

  const handleEnabledChange = (e) => {
    if (e.target.checked === true) {
      setEnabled(true);
    } else if (e.target.checked === false) {
      setEnabled(false);
    }
  };
  function rightsList() {
    let groupList = [];

    for (let i = 0; i < rolesUI.length; i++) {
      let subGroupsList = [];

      if (rolesUI[i].subGroups) {
        for (let k = 0; k < rolesUI[i].subGroups.length; k++) {
          let rightsList1 = [];
          const subGroup = rolesUI[i].subGroups[k];
          for (let j = 0; j < subGroup.rights.length; j++) {
            const right = subGroup.rights[j];
            rightsList1.push(
              <div className="flex-iac" style={{ width: "33%", float: "left" }}>
                <Checkbox
                  color="primary"
                  size="small"
                  style={{ padding: "5px" }}
                  value={right.id}
                  onChange={(e) => onAdditionalRightsChange(e)}
                  checked={
                    roleDefaultRights.includes(right.id) ||
                    addRights.includes(right.id)
                  }
                  disabled={roleDefaultRights.includes(right.id)}
                />
                {props.t(`administration.rolesAndRights.${right.name}`, {
                  defaultValue: right.name,
                })}
              </div>
            );
          }

          subGroupsList.push(
            <fieldset style={{ marginBottom: "20px" }}>
              <legend>
                {" "}
                {props.t(
                  `administration.rolesAndRights.groups.${subGroup.name}`,
                  {
                    defaultValue: subGroup.name,
                  }
                )}
              </legend>
              {rightsList1}
            </fieldset>
          );
        }
      }

      let rightsList2 = [];
      if (rolesUI[i].rights) {
        for (let j = 0; j < rolesUI[i].rights.length; j++) {
          const right = rolesUI[i].rights[j];
          rightsList2.push(
            <div className="flex-iac">
              <Checkbox
                color="primary"
                size="small"
                style={{ padding: "5px" }}
                value={right.id}
                onChange={(e) => onAdditionalRightsChange(e)}
                checked={
                  roleDefaultRights.includes(right.id) ||
                  addRights.includes(right.id)
                }
                disabled={roleDefaultRights.includes(right.id)}
              />
              {props.t(`administration.rolesAndRights.${right.name}`, {
                defaultValue: right.name,
              })}
            </div>
          );
        }
      }
      groupList.push(
        <fieldset
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            marginBottom: "30px",
          }}
        >
          <legend>
            {props.t(
              `administration.rolesAndRights.groups.${rolesUI[i].name}`,
              {
                defaultValue: rolesUI[i].name,
              }
            )}
          </legend>
          {subGroupsList.length > 0 && subGroupsList}
          {rightsList2.length > 0 && rightsList2}
        </fieldset>
      );
    }

    return <div>{groupList}</div>;
  }

  function ceduCreateEditUser() {
    function createUser() {
      if (username && username.includes(" ")) {
        setErrorMessage(props.t("login.usernamerules"));
        setFailShow(true);
        return;
      }

      if (password != passwordConfirm) {
        setErrorMessage(
          props.t("administration.benutzer.fehlerPasswoerterStimmenNicht")
        );
        setFailShow(true);
        return;
      }

      const data = {
        username: username,
        password: password,
        eMail: email,
        departmentId: selectedDepartment?.value ?? null,
        roleIds: [selectedRoles[0].value],
        additionalRights: addRights,
        languageCode: language.value,
      };

      axios
        .post(link + "/api/User/create", data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          props.onChange();
        })

        .catch((error) => {
          if (error.response.status == "400") {
            setErrorMessage(error.response.data);
          } else {
            setErrorMessage(props.t("allgemein.fehlgeschlagen"));
          }
          setFailShow(true);
        });
    }

    function editUser() {
      if (username && username.includes(" ")) {
        setErrorMessage(props.t("login.usernamerules"));
        setFailShow(true);
        return;
      }
      if (password.length > 0 && password != passwordConfirm) {
        setErrorMessage(
          props.t("administration.benutzer.fehlerPasswoerterStimmenNicht")
        );
        setFailShow(true);
        return;
      }

      const data = {
        username: username,
        password: password,
        departmentId: selectedDepartment?.value ?? null,
        eMail: email,
        roleIds: [selectedRoles[0].value],
        additionalRights: addRights,
        languageCode: language.value,
      };

      axios
        .put(link + "/api/User/update", data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          props.onChange();
        })

        .catch((error) => {
          if (error.response.status == "400") {
            setErrorMessage(error.response.data);
          } else {
            setErrorMessage(props.t("allgemein.fehlgeschlagen"));
          }
          setFailShow(true);
        });
    }

    function handleValidSubmit() {
      if (data != null) {
        editUser();
      } else {
        createUser();
      }
    }

    function cancelSubmit() {
      props.onChange();
    }

    return (
      <AvForm
        onValidSubmit={() => {
          handleValidSubmit();
        }}
      >
        {props.error && props.error ? (
          <Alert color="danger">{props.error}</Alert>
        ) : null}

        <div>
          <div style={{ marginTop: "20px" }}>
            <h3 className="">{heading}</h3>

            <div className="form-group" style={{ width: "50%" }}>
              <AvField
                style={{ height: "25px" }}
                name="username"
                autoComplete="new-username"
                label={props.t("login.labelBenutzername") + ":"}
                value={username}
                className="form-control"
                type="username"
                required
                onChange={(e) => usernameChange(e.target.value)}
              />
              <p>{props.t("login.usernamerules")}</p>
            </div>

            <div className="form-group" style={{ width: "50%" }}>
              <AvField
                style={{ height: "25px" }}
                name="email"
                autoComplete="new-email"
                label={props.t("administration.benutzer.labelEMail") + ":"}
                value={email}
                className="form-control"
                type="email"
                required
                onChange={(e) => emailChange(e.target.value)}
              />
            </div>

            <div className="form-group" style={{ width: "50%" }}>
              <AvField
                style={{ height: "25px" }}
                name="password"
                autoComplete="new-password"
                label={props.t("login.labelPasswort") + ":"}
                value={password}
                type="password"
                required={password.length > 0}
                onChange={(e) => passwordChange(e.target.value)}
              />
            </div>

            <div className="form-group" style={{ width: "50%" }}>
              <AvField
                style={{ height: "25px" }}
                name="passwordConfirm"
                autoComplete="new-password"
                label={
                  props.t("administration.benutzer.labelPasswortBestaetigung") +
                  ":"
                }
                value={passwordConfirm}
                type="password"
                required={password.length > 0}
                onChange={(e) => passwordChangeConfirm(e.target.value)}
              />
              <p>{props.t("login.fehlerPasswortAenderung_2")}</p>
            </div>

            {/* <div style={{ marginTop: "10px" }}>
              <div>{props.t("administration.benutzer.2faAuth")}:</div>
              <Checkbox
                color="primary"
                size="small"
                checked={enabled}
                style={{ padding: "0px", marginRight: "10px" }}
                onChange={handleEnabledChange}
              />
              {props.t("administration.benutzer.2faAuthActivate")}
            </div> */}


            <div style={{ marginTop: "10px" }}>
              <div>
                {props.t("administration.benutzer.labelDepartment")}:
              </div>
              <div style={{ width: "50%", marginTop: "10px" }}>
                <Select
                    closeMenuOnSelect={true}
                    styles={customStyles}
                    isSearchable={false}
                    isMulti={false}
                    onChange={(value) => setSelectedDepartment(value)}
                    options={optionsDepartments}
                    value={selectedDepartment}
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 3,
                      colors: { ...theme.colors, primary: "#20a0ff" },
                    })}
                />
              </div>
            </div>


            <div style={{ marginTop: "10px" }}>
              <div>
                {props.t("administration.benutzer.labelSpracheAfterLogin")}:
              </div>
              <div style={{ width: "50%", marginTop: "10px" }}>
                <Select
                  closeMenuOnSelect={true}
                  styles={customStyles}
                  isSearchable={false}
                  isMulti={false}
                  onChange={languageChange}
                  options={optionsLanguages}
                  value={language}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 3,
                    colors: { ...theme.colors, primary: "#20a0ff" },
                  })}
                />
              </div>
            </div>
            <div style={{ width: "100%", marginTop: "15px" }}>
              <div>{props.t("administration.benutzer.labelRolle")}</div>
              <div style={{ width: "50%", marginTop: "10px" }}>
                <Select
                  closeMenuOnSelect={true}
                  styles={customStyles}
                  isSearchable={false}
                  isMulti={false}
                  onChange={onRoleChange}
                  options={rolesList}
                  value={selectedRoles}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 3,
                    colors: { ...theme.colors, primary: "#20a0ff" },
                  })}
                  required
                />
              </div>
            </div>

            <div style={{ marginTop: "15px" }}>
              <div>{props.t("administration.benutzer.additionalRights")}</div>
              <button
                type="button"
                style={{ width: "25%", marginTop: "10px" }}
                className="button"
                onClick={() => toggleRightsSwitch()}
              >
                {toggleRights
                  ? props.t("administration.benutzer.hide")
                  : props.t("administration.benutzer.show")}
              </button>
              {toggleRights && rightsList()}
            </div>

            {failShow == true && (
              <div
                className="login-fail"
                style={{
                  marginTop: "20px",
                  marginBottom: "20px",
                  fontSize: "100%",
                }}
              >
                {errorMessage}
              </div>
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "20px",
                marginBottom: "20px",
              }}
            >
              <button
                type="submit"
                className="button"
                style={{ width: "100px" }}
                onClick={() => cancelSubmit()}
              >
                {props.t("allgemein.abbruch")}
              </button>
              <button
                type="submit"
                className="button"
                style={{ marginLeft: "10px", width: "100px" }}
              >
                {props.t("allgemein.speichern")}
              </button>
            </div>
          </div>
        </div>
      </AvForm>
    );
  }

  function renderOption() {
    if (selectedType == "createEditDeleteUser") {
      return ceduCreateEditUser();
    }
  }

  return <div id="">{renderOption()}</div>;
};

export default withNamespaces()(CreateEditUser);
